<template>
	<div v-if="!data.loading" class="row">
		<div class="row">
			<div class="col-sm-8 mx-auto">
				<div class="card mb-3">
					<div class="row g-0">
						<div
							class="col-md-4 d-flex flex-column justify-content-evenly align-items-center overflow-hidden"
						>
							<div class="profile">
								<img
									class="user-profile round-img shadow-lg"
									:src="store.state.user.image"
									alt="profile"
								/>
							</div>

							<h2 class="text-warning">
								{{ data.user.firstName }}
								{{ data.user.lastName }}
							</h2>
						</div>
						<div class="col-md-8">
							<div class="card-body">
								<table class="table table-striped table-hover">
									<tbody>
										<tr>
											<th>User Name</th>
											<td>
												{{ data.user.firstName }}
												{{ data.user.lastName }}
											</td>
										</tr>
										<tr>
											<th>Email</th>
											<td>
												{{ data.user.email || "-" }}
											</td>
										</tr>
										<tr>
											<th>Phone</th>
											<td>
												{{ data.user.phone || "-" }}
											</td>
										</tr>
										<tr>
											<th>Assigned Area</th>
											<td>
												{{ data.user.area || "-" }}
											</td>
										</tr>
										<tr>
											<th>Booking Amount Target</th>
											<td>
												{{ data.user.bookingTarget || "-" }}
											</td>
										</tr>
										<tr>
											<th>Enquiry Target</th>
											<td>
												{{ data.user.enquiryTarget || "-" }}
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div
				v-if="!data.loading && store.state.user.role[0] === roles.env_admin"
				class="row mt-5 py-4"
			>
				<div class="col-sm-2"></div>
				<div class="col-sm-8">
					<div class="custom-rounded-15 shadow-lg p-4">
						<UserEdit />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { reactive, inject, onMounted } from "vue";
	import { useRouter } from "vue-router";
	import toast from "@/config/toast";
	import API from "@/config/api";

	import UserEdit from "./UserEdit.vue";

	export default {
		name: "TheProfile",
		components: {
			UserEdit,
		},
		setup: () => {
			const store = inject("store");
			const masterStore = inject("masterStore");

			const roles = reactive({
				env_admin: process.env.VUE_APP_USER_ADMIN,
			});
			const userImage = reactive({
				url: process.env.VUE_APP_IMAGE_PREFIX,
			});

			const router = useRouter();
			if (!store.state.auth.isAuth) router.push("Login");

			const data = reactive({
				user: {},
				loading: true,
				noRecords: false,
			});

			const getUser = async () => {
				try {
					const response = await API.privateRequest.get(
						`users?id=${store.state.user.id}`,
					);
					console.log("user response :", response.data.data);
					if (!response.data.data.length) return (data.noRecords = true);
					data.user = response.data.data[0];
					masterStore.methods.setId("edit", response.data.data[0]._id),
						masterStore.methods.changeData(response.data.data[0]),
						masterStore.methods.changeComponent("edit");
					data.loading = false;
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}

					toast.error(message, true);
				}
			};

			onMounted(() => {
				getUser();
			});

			return {
				data,
				store,
				roles,
				userImage,
			};
		},
	};
</script>
<style scoped>
	.profile {
		height: 200px;
		width: 200px;
		border-radius: 50%;
		overflow: hidden;
	}
	.user-profile {
		width: 200px;
		height: 200px;
		border-radius: 50%;
	}
</style>
